export default __webpack_public_path__ + "static/media/Wind.46406665.svg";